import { WithTheme } from '@issuemanager/apps/client/theme';
import { Box, Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/system';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorObject } from '../@types/forms';
import { SideToastWithIssueTypes } from './toasts';

const StyledBox = styled(Box)`
  position: fixed;
  right: 0;
  top: 0;
  margin-right: 22px;
  margin-top: 64px;
  z-index: 100;
`;

const StyledErrorTypography = styled(Typography)<WithTheme<TypographyProps>>(
  ({ theme }) => ({
    fontWeight: theme.tokens.semantic.fontWeight.link.value,
    color: theme.tokens.semantic.color.link.default.value,
  }),
);

type Props = {
  onClose: () => void;
  errors: ErrorObject;
};

export function ErrorFloatingCard(props: Props) {
  const { errors, onClose } = props;
  const { t } = useTranslation('common');
  const title = t('errors.form.toast.title');
  const required = t('errors.form.toast.required');
  // TODO: map all the possible errors. This needs the UX content to be done
  // to make this dynamic `errors.form.toast.${validationKey}`
  // where validationKey is key of RegisterOptions
  const review = t('errors.form.toast.invalid');

  const mapValidationWithName = (validation: string) => {
    switch (validation) {
      case 'required':
        return required;
      default:
        return review;
    }
  };

  const issueTypes = Object.entries(errors).reduce((pre, cur) => {
    if (cur[1].length) {
      const issueType: { name: string; child: ReactNode } = {
        name: mapValidationWithName(cur[0]),
        child: cur[1].map((error) => (
          <StyledErrorTypography key={error.label}>
            {error.label}
          </StyledErrorTypography>
        )),
      };
      pre.push(issueType);
    }
    return pre;
  }, [] as { name: string; child: ReactNode }[]);

  return (
    <StyledBox>
      <SideToastWithIssueTypes
        title={title}
        issueTypes={issueTypes}
        onClose={onClose}
        type='error'
      />
    </StyledBox>
  );
}
